import LinkButton from '@stories/Components/Buttons/LinkButton/LinkButton';
import React from 'react';
import S from './RichText.styles';
const RichText = ({ align, content, leadParagraphWide = false, leadParagraphBold = false, width = 'narrow', longCta, cta, hasBackground = false, flush = 'none', }) => {
    return (React.createElement(S.Container, { isActive: true, innerWidth: width, hasBackground: hasBackground, flush: flush, "data-long-cta": longCta },
        React.createElement(S.ContentBlock, { align: align },
            React.createElement(S.Content, { align: align, dangerouslySetInnerHTML: { __html: content }, leadParagraphWide: leadParagraphWide, leadParagraphBold: leadParagraphBold }),
            cta?.text && (React.createElement(LinkButton, { themeOption: cta?.themeOption, href: cta?.url, target: cta?.target, title: cta?.text })))));
};
export default RichText;
